export const colorsTypography = {
  colorTypographyLight: 'rgba(255, 255, 255, 0.7);',
};
